import React from 'react';

export const ensureRefreshImageSrc = async (
  e: React.SyntheticEvent<HTMLImageElement, Event>,
) => {
  await new Promise((resolve) => setTimeout(resolve, 200));

  const elem = e.currentTarget;
  const src = elem.src;
  elem.src = src;
};
